import { pluralize } from "shared/Pluralize";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";

import { ManagedUserGroupView } from "../../types";

const IdpGroupMappingTableUsersCell = ({
  item: group,
  ...cellProps
}: TableSimpleCellProps<ManagedUserGroupView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{`${group.memberCount} ${pluralize("user", group.memberCount)}`}</TableCellText>
    </TableSimpleCell>
  );
};

export default IdpGroupMappingTableUsersCell;
